import secureStorage from "hooks/secureStorage";
import { useEffect } from "react";
import { createContext, useContext, useState } from "react";

// Création du contexte
const AppContext = createContext();


// Provider pour partager les données
export const AppProvider = ({ children }) => {
    const enqueteObj = secureStorage.getItem('enquete_courante')
    const [cenquete, setCEnquete] = useState(JSON.parse(enqueteObj));

    // Sauvegarde automatique dans secureStorage à chaque changement
    useEffect(() => {
        secureStorage.setItem("enquete_courante", JSON.stringify(cenquete));
    }, [cenquete]);

    return (
        <AppContext.Provider value={{ cenquete, setCEnquete }}>
            {children}
        </AppContext.Provider>
    );
};

// Hook personnalisé pour utiliser le contexte facilement
export const useAppContext = () => useContext(AppContext);
